import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  CustomerSalesZoneBean,
  CustomerSalesZoneSearchCriteria,
  RestCustomerSalesZoneListRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class CustomerSalesZoneListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editCustomerSalesZone = (e, rowdata) => {
    if (e.detail === 1) this.props.editCustomerSalesZone(rowdata);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  deleteCustomerSalesZone = (e, rowData) => {
    if (e.detail === 1) this.props.deleteCustomerSalesZone(rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };
  render() {
    let customerSalesZone_list = this.props.customerSalesZone_list;
    let customerSalesZoneData = this.props.customerSalesZoneData;
    return (
      <div>
        <div>
          <Row>
            <Col sm="2">
              <FormLabel id="searchBarLabel">CustomerSalesZone</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={customerSalesZoneData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {customerSalesZone_list != null ? (
              <tbody>
                {customerSalesZone_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editCustomerSalesZone(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteCustomerSalesZone(e, Info.code)
                        }
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {customerSalesZone_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class CustomerSalesZoneEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      customerSalesZoneData: this.props.customerSalesZoneData,
    };
  }
  componentDidMount() {
    this.setInputFocus();
  }
  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  saveCustomerSalesZone = (e) => {
    this.props.saveCustomerSalesZone(this.state.customerSalesZoneData);
  };
  closeCustomerSalesZoneEntryForm() {
    this.props.closeCustomerSalesZoneEntryForm();
  }
  render() {
    let customerSalesZoneData = this.props.customerSalesZoneData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={customerSalesZoneData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter CustomerSalesZoneCode"
              onChange={this.onChange}
              value={customerSalesZoneData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={customerSalesZoneData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={customerSalesZoneData.isActive}
            />
          </Col>
        </Row>
        <br />
      </div>
    );
  }
}
class CustomerSalesZoneList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      customerSalesZone_list: [],
      response: {},
      pageTitle: "Customer Sales Zone",
      customerSalesZoneData: new CustomerSalesZoneBean(),
      pageList: new PageListBean(),
      criteria: new CustomerSalesZoneSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isCustomerSalesZoneListFormOpen: true,
      isCustomerSalesZoneEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }
  moduleCaption = "Customer Sales Zone";
  opentypeforms = () => {
    let customerSalesZoneCode = this.state.customerSalesZoneData;
    this.editCustomerSalesZone(customerSalesZoneCode.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  cleardata = () => {
    let customerSalesZoneData = new CustomerSalesZoneBean();
    customerSalesZoneData.companyCode = this.companyCode;
    this.setState({ customerSalesZoneData: customerSalesZoneData });
  };
  saveCustomerSalesZoneResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeCustomerSalesZoneEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveCustomerSalesZone = (customerSalesZoneData) => {
    if (customerSalesZoneData.isFetched == true) {
      if (
        SecurityAccessManager.CustomerSalesZoneMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateCustomerSalesZone(
          customerSalesZoneData,
          this.saveCustomerSalesZoneResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CustomerSalesZoneMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createCustomerSalesZone(
          customerSalesZoneData,
          this.saveCustomerSalesZoneResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  editCustomerSalesZoneResponse = (response) => {
    if (response.data != null) {
      if (response.data.customerSalesZoneBean != null) {
        let customerSalesZoneData = response.data.customerSalesZoneBean;
        this.setState({
          customerSalesZoneData: customerSalesZoneData,
        });
        this.disable();
      }
    }
    this.openCustomerSalesZoneEntryForm();
  };
  editCustomerSalesZone = (customerSalesZoneCode) => {
    let criteria = new CustomerSalesZoneSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = customerSalesZoneCode;
    if (SecurityAccessManager.CustomerSalesZoneMaintenanceView_IsAccessible()) {
      MasterService.readCustomerSalesZone(
        criteria,
        this.editCustomerSalesZoneResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_customerSalesZonedata = this.state.customerSalesZoneData;
    temp_customerSalesZonedata[e.target.name] = e.target.value;
    this.setState({
      customerSalesZoneData: temp_customerSalesZonedata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let customerSalesZoneData = this.state.customerSalesZoneData;
    customerSalesZoneData.companyCode = this.companyCode;
    customerSalesZoneData.code =
      this.state.customerSalesZoneData.code.toUpperCase();
    this.clearError();
    this.saveCustomerSalesZone(customerSalesZoneData);
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeCustomerSalesZoneEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openCustomerSalesZoneEntryForm = () => {
    this.setState({
      isCustomerSalesZoneListFormOpen: false,
      isCustomerSalesZoneEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };
  closeCustomerSalesZoneEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCustomerSalesZoneListFormOpen: true,
      isCustomerSalesZoneEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadCustomerSalesZoneResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerSalesZonePageList != null
    ) {
      let customerSalesZoneList = new Array();
      if (
        !isEmptyArray(response.data.customerSalesZonePageList.customerZones)
      ) {
        customerSalesZoneList =
          response.data.customerSalesZonePageList.customerZones;
        customerSalesZoneList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.customerSalesZonePageList.currentPage;
      pageList.pageSize = response.data.customerSalesZonePageList.pageSize;
      pageList.totalCount = response.data.customerSalesZonePageList.totalCount;
      this.setState({
        customerSalesZone_list: customerSalesZoneList,
        pageList: pageList,
      });
    }
  };
  loadCustomerSalesZonePage = (pageList, searchCriteria) => {
    let criteria = new CustomerSalesZoneSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestCustomerSalesZoneListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.CustomerSalesZoneMaintenanceView_IsAccessible()) {
      MasterService.getCustomerSalesZonePageList(
        requestInput,
        this.loadCustomerSalesZoneResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new CustomerSalesZoneSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCustomerSalesZonePage(pageInput, criteria);
  };
  deleteCustomerSalesZone = (rowData) => {
    let criteria = new CustomerSalesZoneSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData;
    if (
      SecurityAccessManager.CustomerSalesZoneMaintenanceDelete_IsAccessible()
    ) {
      MasterService.deleteCustomerSalesZone(
        criteria,
        this.deleteCustomerSalesZoneResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteCustomerSalesZoneResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.customerSalesZone_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerSalesZone_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isCustomerSalesZoneListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}
        {!this.state.isCustomerSalesZoneListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isCustomerSalesZoneListFormOpen && (
          <CustomerSalesZoneListForm
            customerSalesZone_list={this.state.customerSalesZone_list}
            pageList={this.state.pageList}
            opentypeforms={this.opentypeforms}
            customerSalesZoneData={this.state.customerSalesZoneData}
            editCustomerSalesZone={this.editCustomerSalesZone}
            deleteCustomerSalesZone={this.deleteCustomerSalesZone}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {!this.state.isCustomerSalesZoneListFormOpen && (
          <CustomerSalesZoneEntryForm
            customerSalesZoneData={this.state.customerSalesZoneData}
            closeCustomerSalesZoneEntryForm={
              this.closeCustomerSalesZoneEntryForm
            }
            saveCustomerSalesZone={this.saveCustomerSalesZone}
            editCustomerSalesZone={this.editCustomerSalesZone}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function CustomerSalesZoneAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CustomerSalesZoneList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CustomerSalesZoneAttributeModule;
